import { FileDescriptor } from '@dreryk/command-query-ws-api';

import { HealthcareInstitutionLogoBasic } from './HealthcareInstitutionLogoBasic';
import { HealthcareInstitutionLogoSvg } from './HealthcareInstitutionLogoSvg';

type HealthcareInstitutionLogoProps = {
   readonly fileDescriptor: FileDescriptor;
};

export const HealthcareInstitutionLogo = (props: HealthcareInstitutionLogoProps): JSX.Element => {
   switch (props.fileDescriptor.file!.type) {
      case 'image/svg+xml':
         return <HealthcareInstitutionLogoSvg fileDescriptor={props.fileDescriptor} />;
      default:
         return <HealthcareInstitutionLogoBasic fileDescriptor={props.fileDescriptor} />;
   }
};
